export default __webpack_public_path__ + "static/pt-3330932785d30de111f0daf0d3d9d092.svg";